import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { OcorrenciaReservaPoupancaModel } from '../../../../models/ocorrencia-reserva-poupanca.model';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { ReservaPoupancaModel } from '../../../../models/reserva-poupanca.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class PBDCReservaPoupancaPdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _formateNumberZeroPipe: FormateNumberZeroPipe,
    private _cpf: CpfPipe
  ) { }

  public funcionarios(pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, ocorrenciaReservaPoupancaModel: Array<OcorrenciaReservaPoupancaModel>,
    reservaPoupancaModel: ReservaPoupancaModel) {

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 30, 20);
    doc.setFontSize(13);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`Reserva de Poupança`, 85, 50)

    doc.autoTable({
      startY: 60
    })



    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      columnStyles: {
        0: { cellWidth: 30 }
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome]],
    });


    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9
      },
      columnStyles: {
        2: { halign: 'right' }
      },
      head: [[
        `Total de Contribuições
              (a)
          ${this._decimalPipe.transform(reservaPoupancaModel.vlTotAtualizacao)}`
        ,`Data Ref da Atualização Monetária

         ${(reservaPoupancaModel.dtBaseAtualizacao.substring(3))}`
        , `Atualização Monetária
               (b)
        ${this._decimalPipe.transform(reservaPoupancaModel.vlTotContribuicao)}`
        , `Valor Atualizado
    (c) = (a) + (b)
      ${this._decimalPipe.transform(reservaPoupancaModel.vlTxAdministracao)}*`]]
    });

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
        halign: 'right'
      },
      head: [[`Valor da Cota Atual: ${this._decimalPipe.transform(reservaPoupancaModel.vlIndiceAtual)}`]]
    });


    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      styles: {
        fontSize: 8,
        halign: 'center'
      },
      head: this._headRows(),
      body: this._bodyRows(ocorrenciaReservaPoupancaModel)
    });


    doc.setFontSize(9);
    doc.setFont('Source Sans Pro');
    doc.text(`
      (*) Valor resgatável somente na hipótese de desligamento do participante do Plano de Benefício Definido
      Centrus - PBDC, obedecidos os critérios estabelecidos no art. 37 do Regulamento.
      (**) Contribuições posteriores a 12/2008 suportadas com recursos do Fundo Previdencial de Contribuições.
      (***) Atualização mensal com base na variação do IPCA acrescida de juros de 3.7% a.a.
      `, 14, doc.previousAutoTable.finalY + 4);


    doc.setProperties({
      title: 'Declaração',
      subject: `Declaração gerado em ${new Date('dd/mm/yyy')} `,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
      ? (window.open(URL.createObjectURL(doc.output('blob'))))
      : this.handleFile(doc.output('blob'), 'pbdc-reserva.pdf');
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }



    const blob = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;

    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    setTimeout(() => { // firefox
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }
  private _bodyRows(ocorrenciaReservaPoupancaModel: Array<OcorrenciaReservaPoupancaModel>) {
    const body = []

    ocorrenciaReservaPoupancaModel.map(item => {
      body.push({
        data: item.dtReferencia,
        contribuicao: this._decimalPipe.transform(item.vlNominal),
        vlCota: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlIndiceAcumulado, '1.1-2')),
        quantCotas: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.qtContribuicao, '1.1-2')),
        contAtualizada: this._decimalPipe.transform(item.vlAtualizado)
      })
    })
    return body;
  }

  private _headRows() {
    return [{
      data: 'Data-Base',
      contribuicao: 'Contribuição**',
      vlCota: 'Valor da Cota***',
      quantCotas: 'Quantidade de Cotas',
      contAtualizada: 'Contribuição Atualizada'
    },
    ]
  }






}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-reserva-poupanca-pdf copy.ts